/* Oak Forge: no seletor do Kaching o texto vazio vem "Select"; a origem mostra "Select Colour" e "Select Size".
   Troca o texto conforme a opcao (o Kaching re-renderiza: observer idempotente). */
(function () {
  function rotulo(el, nome) {
    if (el.textContent.trim() === 'Select') el.textContent = 'Select ' + nome;
  }
  function ajusta(raiz) {
    raiz.querySelectorAll('.kaching-bundles__bar-variant-selects').forEach(function (g) {
      var sw = g.querySelector('.kaching-bundles__swatch-dropdown .kaching-bundles__bar-variant-select span');
      if (sw) rotulo(sw, 'Colour');
      g.querySelectorAll('select.kaching-bundles__bar-variant-select').forEach(function (s) {
        var o = s.options[0];
        if (!o || o.text.trim() !== 'Select') return;
        var vals = [].slice.call(s.options, 1).map(function (x) { return x.text; }).join(' ');
        o.text = /W\d|\b(S|M|L|XL|2XL)\b/.test(vals) ? 'Select Size' : 'Select Colour';
      });
    });
  }
  function liga() {
    var alvo = document.querySelector('kaching-bundle') || document.body;
    ajusta(alvo);
    new MutationObserver(function () { ajusta(alvo); }).observe(alvo, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', liga); else liga();
})();
